import React from 'react';
import { ILayoutProps, ScrollView, UserHeader } from '../..';

export default function AnonymousLayout(props: ILayoutProps) {
    return (
        <ScrollView>
            <div>
                <UserHeader isEmpty withLogo />
                {props.children}
            </div>
        </ScrollView>
    );
}
